module.exports = __webpack_public_path__ + "static/mevia-env1@2x-min-02b8be3bb1543e569dd2abf45c6df875.png";